import React from 'react';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import oidcConfigs from '../oidc-configs';
import { decodeUrl } from '../lib/base64';

interface QueryParams {
  url?: string;
  clientId?: string;
  realm?: string;
  auth?: string;
  state?: string;
}

interface ConfigSettings {
  url?: string;
  clientId?: string;
  realm?: string;
}

interface AuthState {
  query?: {
    auth?: string;
  };
  clientId?: string;
  realm?: string;
  url?: string;
  path?: string;
}

const ConfigContext = React.createContext<ConfigSettings>({
  url: undefined,
  clientId: undefined,
  realm: undefined,
});

function decodeState(state?: string) {
  if (!state) return undefined;
  return JSON.parse(decodeUrl(state)) as AuthState;
}

export function useConfig() {
  const context = React.useContext(ConfigContext);
  if (!context) throw new Error('useConfig must be used inside the Config');
  return context;
}

export default function Config({ children }: React.PropsWithChildren) {
  const location = useLocation();

  const values = React.useMemo(() => {
    const q = qs.parse(location.search.replace(/^\?/ig, '')) as QueryParams;
    const state = decodeState(q.state);

    const oidcConfig = oidcConfigs[q.auth];

    const applicationConfig = {
      url: q.url || oidcConfig?.url || state?.url,
      clientId: q.clientId || oidcConfig?.clientId || state?.clientId,
      realm: q.realm || oidcConfig?.realm || state?.realm,
    };

    console.log('Application config');
    console.log('------------------');
    console.log(`URL:       ${applicationConfig.url}`);
    console.log(`Client ID: ${applicationConfig.clientId}`);
    console.log(`Realm:     ${applicationConfig.realm}`);
    console.log(`Query:     ${JSON.stringify(q)}`);
    console.log(`State:     ${JSON.stringify(state)}`);

    return applicationConfig;
  }, [location]);

  return (
    <ConfigContext.Provider value={values}>
      {children}
    </ConfigContext.Provider>
  );
}
